import { FC, useCallback, useRef} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../../ag-grid.css'
import '../../../../ag-theme-alpine.css'
import { BsRocketTakeoff } from "react-icons/bs"
import { ImCross } from "react-icons/im"

export const ScenarioTable:FC<any> = (props) => {

    const gridRef :any= useRef();

    const {data, setSelectedRow} = props

    const onSelectionChanged = useCallback(() => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        setSelectedRow(selectedRows[0])
      }, []);

    
    const simulatedRenderer = (params:any) => {
        if(params.value === true) {
            return(
                <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <BsRocketTakeoff size={16} />
                </div>
            )
        }
        return(
            <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                <ImCross  size={14} />
            </div>
        )
    }


    return (
        <div className="ag-theme-alpine"  style={{display:'flex',flexDirection:'column', height:'100%', width: '100%' }}>

            <AgGridReact
                ref={gridRef}
                pagination={true}
                rowSelection={'single'}
                onSelectionChanged={onSelectionChanged}
                paginationAutoPageSize={true}
                headerHeight={30}
                rowHeight={30}
                rowData={data}
                enableCellTextSelection>
                <AgGridColumn  resizable={true} flex={1} hide  field={"id"}></AgGridColumn>
                <AgGridColumn  sort={'asc'} suppressNavigable={true} cellStyle={{borderRight:'1px solid #dee2e6'}} sortable  headerClass={"header-resize"}   flex={0.55} headerName={"Escenario ID"} field={"id_scenario"}></AgGridColumn>
                <AgGridColumn sortable  suppressNavigable={true} cellStyle={{borderRight:'1px solid #dee2e6'}}  headerClass={"header-resize"}  flex={1.5} headerName={"Nombre Escenario"} field={"name_scenario"}></AgGridColumn>
                <AgGridColumn   suppressNavigable={true} cellStyle={{borderRight:'1px solid #dee2e6'}} sortable  headerClass={"header-resize"}  flex={0.5} headerName={"Fecha Creación"} field={"creation_date"}></AgGridColumn>
                <AgGridColumn   suppressNavigable={true} cellStyle={{borderRight:'1px solid #dee2e6'}} sortable  headerClass={"header-resize"} cellRenderer={simulatedRenderer}  flex={0.35} headerName={"Simulado"} field={"simulated"}></AgGridColumn>
          
            </AgGridReact>
        </div>
    )
}